<div class="container">
    <p-tabs class="edit-view" scrollable [value]="activeTab" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab [value]="0" class="tab-header">
                {{ 'label.Vacancies' | translate }}
            </p-tab>

            <p-tab [value]="1" class="tab-header">
                {{ 'label.Invitations' | translate }}
            </p-tab>

            <p-tab [value]="2" class="tab-header">
                {{ 'label.CvBoxes' | translate }}
            </p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel [value]="0">
                <div class="tab">
                    <app-spinner [isLoading]="vacancyApplicationIsLoading$ | async" [isFixedPosition]="false">
                        @if (activeTab === vacanciesTab) {
                            <app-jobseeker-applies-vacancy></app-jobseeker-applies-vacancy>
                        }
                    </app-spinner>
                </div>
            </p-tabpanel>

            <p-tabpanel [value]="1">
                <div class="tab">
                    <router-outlet></router-outlet>
                </div>
            </p-tabpanel>

            <p-tabpanel [value]="2">
                <div class="tab">
                    <app-spinner [isLoading]="cvBoxApplicationIsLoading$ | async" [isFixedPosition]="false">
                        @if (activeTab === cvBoxesTab) {
                            <app-jobseeker-applies-cv-box></app-jobseeker-applies-cv-box>
                        }
                    </app-spinner>
                </div>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>